import React from 'react';
import { AlertCircle, RotateCw } from 'lucide-react';
import Button from './Button';

/**
 * ErrorState 컴포넌트
 * 데이터 로드 실패 등 에러 상황을 일관되게 표시하고 "다시 시도" 액션을 제공한다.
 * (이전에는 대부분 페이지가 catch 에서 toast 만 띄우고 빈 화면을 남겼음)
 *
 * @param {Object} props
 * @param {string} props.title - 에러 제목
 * @param {string} props.message - 안내 메시지
 * @param {Function} props.onRetry - 다시 시도 핸들러 (없으면 버튼 미표시)
 * @param {string} props.retryLabel - 재시도 버튼 라벨
 * @param {string} props.className
 */
const ErrorState = ({
  title = '데이터를 불러오지 못했습니다',
  message = '잠시 후 다시 시도해주세요.',
  onRetry,
  retryLabel = '다시 시도',
  className = '',
}) => {
  return (
    <div
      role="alert"
      className={`flex flex-col items-center justify-center py-16 px-4 text-center ${className}`}
    >
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-50">
        <AlertCircle className="h-8 w-8 text-red-500" />
      </div>
      <h3 className="mb-1 text-lg font-semibold text-primary-900">{title}</h3>
      <p className="mb-6 text-sm text-accent-700">{message}</p>
      {onRetry && (
        <Button variant="outline" onClick={onRetry}>
          <span className="inline-flex items-center gap-2">
            <RotateCw className="h-4 w-4" />
            {retryLabel}
          </span>
        </Button>
      )}
    </div>
  );
};

export default ErrorState;
